import { FormInputTypes } from '@components/_old/dynamicForm';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const getAmendmentFiltersView = (
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord,
  layoutName: 'amendment'
): IListingFilterWidgetSection[] => {
  return [
    {
      title: 'Filters',
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormInputTypes.newmultiselect,
          value: filterValues.line || [],
          placeholder: 'Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line }
        },
        businessPartner: {
          name: 'businessPartner',
          title: 'Broker',
          type: FormInputTypes.newmultiselect,
          value: filterValues.businessPartner || [],
          placeholder: 'Broker',
          triggerUpdate: true,
          selectOptions: { ...lovs.businessPartner }
        },
        type: {
          name: 'type',
          title: 'Amendment Type',
          type: FormInputTypes.newmultiselect,
          value: filterValues.type || [],
          placeholder: 'Amendment Type',
          triggerUpdate: true,
          selectOptions: { ...lovs.type }
        },
        subType: {
          name: 'subType',
          title: 'Amendment Sub-Type',
          type: FormInputTypes.newmultiselect,
          value: filterValues.subType || [],
          placeholder: 'Amendment Sub-Type',
          triggerUpdate: true,
          selectOptions: { ...lovs.subType }
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status }
        },
        issueOn: {
          name: 'issueOn',
          title: 'Amendment Issue Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.issueOn || [],
          placeholder: 'Select Date Range',
          triggerUpdate: true
        },
        effectiveDate: {
          name: 'effectiveDate',
          title: 'Amendment Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.effectiveDate || [],
          placeholder: 'Select Date Range',
          triggerUpdate: true
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues.createdOn || [],
          placeholder: 'Select Date Range',
          triggerUpdate: true
        }
      }
    }
  ];
};
